<template>
  <div id="ManifestImportFilters">
    <v-expansion-panels class="px-5 py-1" accordion>
      <v-expansion-panel class="elevation-1">
        <v-expansion-panel-header color="#f2f2f2" class="px-4">
          <span>Filtrar por</span>
          <template v-slot:actions>
            <v-icon color="black"> mdi-chevron-down </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mt-2 pb-1">
            <v-col cols="12" md="4">
              <v-menu
                ref="menuDateStart"
                v-model="menuDateStart"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedDateInitial"
                    label="Data Inicial da Consulta"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateInitial"
                  :max="getMaxDateForInitial()"
                  :active-picker.sync="activePicker"
                  locale="pt-br"
                  @change="saveInitial"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="4">
              <v-menu
                ref="menuDateEnd"
                v-model="menuDateEnd"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedDateEnd"
                    label="Data Final da Consulta"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateEnd"
                  :active-picker.sync="activePicker"
                  :min="getMinDateForEnd()"
                  :max="getTodayDate()"
                  locale="pt-br"
                  @change="saveEnd"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="responsibleSelected"
                :items="users"
                label="Usuário responsável / Importado por"
                item-text="name"
                item-value="userId"
                @change="saveResponsible"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-combobox
                v-model="sequenceCodesSelected"
                :search-input.sync="sequenceCodeInput"
                append-icon=""
                label="Número MDF-e"
                hide-selected
                multiple
                chips
                deletable-chips
                @keydown.native="filterInput"
                @change="saveSequeceCode"
              ></v-combobox>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="statusSelected"
                :items="statusShipment"
                label="Status"
                item-text="name"
                item-value="id"
                @change="saveStatus"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" md="12" class="d-flex justify-end align-center">
              <v-btn
                :disabled="!hasFilters"
                elevation="2"
                color="red"
                class="mx-2"
                :dark="hasFilters"
                @click="cleanFilter()"
              >
                Limpar Filtros
              </v-btn>
              <v-btn
                :loading="loading || loadingGetAll"
                :disabled="!hasFilters"
                :dark="hasFilters"
                elevation="2"
                color="green"
                @click="search()"
              >
                Buscar
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import allowedChars from '@/utils/allowedChars';
import comboboxFormatter from '@/utils/comboboxFormatter';
export default {
  name: 'ShipmentImportFilters',
  props: {
    loadingGetAll: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    loading: false,
    menuDateStart: false,
    menuDateEnd: false,
    dateInitial: null,
    dateEnd: null,
    activePicker: null,
    responsibleSelected: null,
    statusSelected: null,
    sequenceCodesSelected: null,
    sequenceCodeInput: '',
    SequenceCodes: [],
    statusShipment: [],
    users: []
  }),
  mounted() {
    this.fetchAllStatusShipment();
    this.fetchAllUsers();
  },
  computed: {
    ...mapGetters('CouriersStore', ['getSummaryData']),

    hasFilters() {
      if (
        this.dateInitial ||
        this.dateEnd ||
        this.responsibleSelected ||
        this.statusSelected ||
        this.sequenceCodesSelected
      ) {
        return true;
      }
      return false;
    },
    formattedDateInitial() {
      if (!this.dateInitial) return '';
      const [year, month, day] = this.dateInitial.split('-');
      return `${day}/${month}/${year}`;
    },
    formattedDateEnd() {
      if (!this.dateEnd) return '';
      const [year, month, day] = this.dateEnd.split('-');
      return `${day}/${month}/${year}`;
    }
  },
  methods: {
    ...mapActions('ManifestStore', ['fetchManifest']),
    ...mapActions('ShipmentStore', ['fetchStatusShipment']),
    ...mapMutations('ManifestStore', [
      'setItemPerPage',
      'setPageNumber',
      'setFilterCreatedAtStart',
      'setFilterCreatedAtEnd',
      'setFilterStatusId',
      'setFilterSequenceCodesIntegration',
      'setFilterResponsibleUserId'
    ]),
    ...mapActions('UserStore', ['fetchListUsers']),
    search() {
      this.$emit('filterSearch');
    },

    async fetchAllStatusShipment() {
      this.loading = true;

      try {
        const data = await this.fetchStatusShipment();

        const statusToRemove = ['Concluído', 'Pronta para importar', 'Duplicado'];
        this.statusShipment = data.filter((item) => !statusToRemove.includes(item.name));
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    async fetchAllUsers() {
      this.loading = true;
      try {
        const data = await this.fetchListUsers();
        this.users = data.sort((a, b) => a.name.localeCompare(b.name));
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    getTodayDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    getMaxDateForInitial() {
      if (this.dateEnd) {
        const dateEnd = new Date(this.dateEnd);
        dateEnd.setDate(dateEnd.getDate() + 1);
        return this.formatDate(dateEnd);
      } else {
        const today = new Date();
        return this.formatDate(today);
      }
    },
    getMinDateForEnd() {
      if (this.dateInitial) {
        const dateInitial = new Date(this.dateInitial);
        dateInitial.setDate(dateInitial.getDate() + 1);
        return this.formatDate(dateInitial);
      } else {
        return null;
      }
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    saveResponsible() {
      this.setFilterResponsibleUserId(this.responsibleSelected);
    },
    saveStatus() {
      this.setFilterStatusId(this.statusSelected);
    },
    saveInitial() {
      this.setFilterCreatedAtStart(this.dateInitial);
    },
    saveEnd() {
      this.setFilterCreatedAtEnd(this.dateEnd);
    },
    filterInput(event) {
      return allowedChars(event, /[0-9,.;/]/);
    },
    saveSequeceCode(value) {
      this.sequenceCodesSelected = comboboxFormatter(value);
      this.setFilterSequenceCodesIntegration(this.sequenceCodesSelected);
    },
    cleanFilter() {
      this.setFilterCreatedAtStart(null);
      this.setFilterCreatedAtEnd(null);
      this.setFilterResponsibleUserId(null);
      this.setFilterStatusId(null);
      this.setFilterSequenceCodesIntegration(null);
      this.$emit('filterSearch');
      this.clearFilterFields();
    },
    clearFilterFields() {
      this.dateInitial = null;
      this.dateEnd = null;
      this.responsibleSelected = null;
      this.statusSelected = null;
      this.sequenceCodesSelected = null;
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep.v-select.v-select--chips .v-select__selections {
  min-height: 50px;
}
</style>
